const ratings = {
  title: "Rate the contractor",
  info: "Your feedback is important to us. What do you think about the completed job?",
  unhappy: "Dissatisfied",
  happy: "Satisfied",
  comment: "Additional information (optional)",
  error: "Select a rating to continue.",
  companyRatings: "Company ratings",
  noComment: "No comment",
  noRatings: "No ratings",
};

export default ratings;
